// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const pps: CountryValidator<"IE"> = createValidator(
  "ie.pps",
  94,
);

export default pps;
export const compact = pps.compact;
export const format = pps.format;
export const validate = pps.validate;
export const generate = (): string =>
  pps.generate?.() ??
  (() => {
    throw new Error(
      "Validator ie.pps cannot generate values",
    );
  })();
